
const digest = 'b588ce907efa685d675c100fc9d012c3e2fc1dfe6bfab3ba8de418c3cfc8d5d1';
const classes = {"wrapper":"_wrapper_qnhjb_1","filterWrapper":"_filterWrapper_qnhjb_7","controls":"_controls_qnhjb_12","calendarWrapper":"_calendarWrapper_qnhjb_17"};
const css = `._wrapper_qnhjb_1 {
  height: calc(100vh - 84px);
  position: relative;
  display: flex;
  flex-direction: column;
}
._wrapper_qnhjb_1 ._filterWrapper_qnhjb_7 {
  position: relative;
  width: 100%;
  z-index: 100;
}
._wrapper_qnhjb_1 ._filterWrapper_qnhjb_7 ._controls_qnhjb_12 {
  display: flex;
  align-items: center;
  justify-content: center;
}
._wrapper_qnhjb_1 ._calendarWrapper_qnhjb_17 {
  flex-grow: 1;
  position: relative;
  overflow-y: scroll;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  